(($, bootstrap) => {
	let $toolTips;

	window.addEventListener('load', init);

	function init() {
		$toolTips = $('a[href="#"][data-bs-toggle="tooltip"]');

		if ($toolTips.length == 0) {
			return false;
		}

        $toolTips.each(initToolTip)

		bind();
	}

    function initToolTip(toolTipIndex, toolTipElement) {
        return new bootstrap.Tooltip(toolTipElement);
    }

    function bind() {
        $toolTips.on('click', onLinkClick);
    }

	function onLinkClick(event) {
		event.preventDefault();
        document.dispatchEvent(new CustomEvent('gform-recaptcha:doAction', { detail: { action: 'tooltip_click' }}));
    }
})(jQuery, bootstrap);